import React, { useState } from 'react';
import { Star, Calendar, Users } from 'lucide-react';
import CallbackModal from './CallbackModal';
import './PackageCard.css';

const PackageCard = ({ 
  title, 
  destinations, 
  duration, 
  rating, 
  reviewCount, 
  originalPrice, 
  discount, 
  finalPrice, 
  images, 
  id 
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isCallbackModalOpen, setIsCallbackModalOpen] = useState(false);
  
  // Safety check for images
  const safeImages = images && Array.isArray(images) && images.length > 0 ? images : ['https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=400&h=300&fit=crop'];

  const handleImageNavigation = (direction) => {
    if (direction === 'next') {
      setCurrentImageIndex((prev) => (prev + 1) % safeImages.length);
    } else {
      setCurrentImageIndex((prev) => (prev - 1 + safeImages.length) % safeImages.length);
    }
  };

  const getDaysFromDuration = (duration) => {
    // Extract days from duration string like "6 days & 5 nights"
    const match = duration.match(/(\d+)/);
    return match ? parseInt(match[1]) : 0;
  };

  return (
    <div className="package-card">
      {/* Image Section */}
      <div className="card-image-container">
        <img 
          src={safeImages[currentImageIndex]} 
          alt={title}
          className="card-image"
        />
        
        {/* Image Navigation */}
        {safeImages.length > 1 && (
          <>
            <button 
              className="image-nav-btn image-nav-left"
              onClick={() => handleImageNavigation('prev')}
            >
              ‹
            </button>
            <button 
              className="image-nav-btn image-nav-right"
              onClick={() => handleImageNavigation('next')}
            >
              ›
            </button>
          </>
        )}
        
        {/* Image Dots */}
        {safeImages.length > 1 && (
          <div className="image-dots">
            {safeImages.map((_, index) => (
              <span
                key={index}
                className={`image-dot ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => setCurrentImageIndex(index)}
              />
            ))}
          </div>
        )}
      </div>

      {/* Duration and Rating */}
      <div className="card-meta">
        <div className="duration">
          <Calendar size={14} />
          <span>{duration}</span>
        </div>
        <div className="rating">
          <Star size={14} className="star-icon" />
          <span>{rating} ({reviewCount})</span>
        </div>
      </div>

      {/* Title */}
      <h3 className="card-title">{title}</h3>

      {/* Destinations */}
      <div className="card-destinations">{destinations}</div>

      {/* Pricing */}
      <div className="card-pricing">
        <div className="price-section">
          <span className="original-price">
            {originalPrice ? `INR ${originalPrice.toLocaleString()}` : 'INR 0'}
          </span>
          <span className="discount">
            {discount ? `SAVE INR ${discount.toLocaleString()}` : 'SAVE INR 0'}
          </span>
        </div>
        <div className="final-price">
          {finalPrice ? `INR ${finalPrice.toLocaleString()}/Adult` : 'INR 0/Adult'}
        </div>
      </div>

      {/* Action Button */}
      <button 
        className="card-action-btn"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsCallbackModalOpen(true);
        }}
      >
        <Users size={16} />
        Request Callback
      </button>

      {/* Callback Modal */}
      <CallbackModal 
        isOpen={isCallbackModalOpen}
        onClose={() => setIsCallbackModalOpen(false)}
      />
    </div>
  );
};

export default PackageCard;
